type FetchLike = (url: string, init?: RequestInit) => Promise<Response>

/**
 * Upload claim evidence files one by one; resolves to the stored urls in order.
 * Throws on the first failed upload so the caller can tell the user (nothing is swallowed).
 */
export const uploadClaimFiles = async (
    files: File[],
    fetchImpl: FetchLike = (url, init) => fetch(url, init),
): Promise<string[]> => {
    const urls: string[] = []
    for (const file of files) {
        const formData = new FormData()
        formData.append('file', file)
        const res = await fetchImpl('/api/upload/playtime-file', { method: 'POST', body: formData })
        if (!res.ok) throw new Error(`Upload failed for ${file.name} (${res.status})`)
        urls.push(((await res.json()) as { fileUrl: string }).fileUrl)
    }
    return urls
}
